(function(angular){
	'use strict';
	
	angular
		.module('educationSiteModule', [
			'affixRevealModule',
			'campaignCtaModule',
			'collapseModule',
			'coreModule',
			'localStorageModule',
			'opportunityFundModule'
		])
		.value('globalConfig', globalConfig);
})(window.angular);